<style>
.workflow-modal-content-edit {
  width: 100%;
  display: inline-block;
  float: left;
  position: relative;
}

.action-tab-select-down {
  text-align: left;
}

.workflow-map-fields {
  width: 100%;
}

.map-fields-name {
  width: 100% !important;
}

.action-dropdown-toggle {
  background: none;
  border: none;
  font-weight: 400;
  color: #00a8ff;
  padding: 2px;
  font-size: 12px;
}

.map-fields-name-action {
  padding-left: 0px;
  padding-top: 2px;
  color: #126588;
  font-size: 12px;
}

.map-fields-name-action-input {
  padding-left: 0px;
  padding-top: 2px;
  color: #126588;
  font-size: 12px;
  margin-top: 16px;
}

.map-fields-name-action sup {
  color: #ff0000;
}

.map-fields-name-action-input sup {
  color: #ff0000;
}

.workflow-map-fields-items a:after {
  content: none;
}

.action-tab-select-down-menu ul li a {
  margin-left: 0;
  padding-left: 10px;
}

.action-tab-select-down-menu {
  width: 200px;
}

.action-dropdown-toggle::after {
  content: '';
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid \9;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  margin-left: 5px;
}

.wf-task-tab-content a:after {
  content: none;
}

.field-input {
  padding-top: 0 !important;
}

.btn-secondary:hover {
  background-color: transparent !important;
  color: #00a8ff;
}

.wf-task-input {
  font-size: 13px;
}

.auto-schedule-select-date-end {
  width: 75%;
  margin-top: -8px;
}

.field-input {
  height: 35px !important;
  min-height: 35px !important;
}

.auto-schedule-select-date-end {
  margin-bottom: 12px;
}

.is-invalid {
  border-bottom: 1px solid #dc3545 !important;
  border-radius: 0;
}

.is-invalid-popup {
  border: 1px solid #dc3545 !important;
}

.item-detail {
  margin-top: 12px;
}

#automated-section .task-action-container .popup-search-filter-items {
  padding: 1px;
}

#automated-section .task-action-container .popup-search-filter-items ul {
  margin-bottom: 0px;
}

#automated-section .task-action-container .popup-search-filter-items ul a {
  width: 100%;
}

#automated-section .vtask-txtbx {
  margin-left: 15px;
  width: 255px;
}

#automated-section .task-action-container .test-query-input {
  margin-left: 15px;
  width: 255px;
}

#automated-section .automation_action_modal_content_task_edit {
  max-width: 800px;
  margin: 0 auto;
}
</style>


<template>
  <!-- Modal -->
  <div class="modal fade automation_action_modal_main" id="create-task-modal" tabindex="-1" role="dialog"
       aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg-custom full-width-dialog " role="document">
      <div class="modal-content automation_action_modal_content automation_action_modal_content_task_edit">
        <div class="modal-body workflow-modal-body">
          <div class="border-body-right-top"></div>

          <div class="tab-content workflow-modal-content-edit" id="myTabContent">
            <div class="workflow-task-header">
              <h2>{{ lang.create_task }}</h2>
            </div>
            <form>
              <div class="wf-task-tab-container task-action-container">
                <div v-if="TaskTable" v-for="field in TaskTable" class="wf-task-tab-content">
                  <div class="row">
                    <div class="col-md-3">
                      <div class="map-fields-name-action-input">
                        {{ field.label }} <sup v-if="field.is_required">*</sup>
                      </div>
                    </div>

                    <!-- related field -->
                    <div v-if="field.field_type == 'relationship'" class="item-detail">
                      <div class="col-auto d-flex align-items-center">
                        <div class="dropdown action-tab-select-down">
                          <input
                              class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
                              v-bind:id="'mapFieldTaskDD-'+field.name"
                              type="button"
                              v-on:click.stop.prevent="openTaskAccordion(field.label)"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                              v-bind:value="InitLabelForTask(field)"
                          />
                          <div v-if="fieldTypeOf(field) && field.field_type != 'autonumber'">
                            <div class="popup-container-main" v-if="checkDD_Task(field.label)"
                                 :id="'popup-container-main-'+level" style="left: 0;top: 100%;"
                                 v-click-outside="outside_task">
                              <div class="popup-container popup-container-modify">
                                <div class="popup-search-filter">
                                  <div class="workflow-selected-field">
                                    <span>{{ lang.select + ' ' + lang.value }}</span>
                                  </div>
                                </div>
                                <div class="workflow-accordion-conautomation_template_editortainer-modify-record">
                                  <AccordionForCreateRecord
                                      :level="level"
                                      :table="SelectedTable.label"
                                      :fields="SelectedTable.fields"
                                      :users="UserTableParent"
                                      :lang="lang"
                                      :mapping_for="field"
                                      :custom="true"
                                      :field_type="field.field_type"
                                      v-on:CreateRecordOptionSelectedEvent="TaskRecordOptionSelected"
                                      :SelectedTableExcludedColumnList="RemoveIDValueForTaskAccordion(SelectedTableExcludedColumnList)"
                                      :CreateRecordMapping="CreateRecordMapping"
                                      :executeHandler="3"
                                  ></AccordionForCreateRecord>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="dropdown-menu action-tab-select-down-menu" style="padding: 0px;" aria-labelledby="dropdownMenuButton">
                              <div class="popup-search-filter-items">
                                  <ul>
                                      <li v-for="(field_dd, index) in field.related_fields" @click="SelectMapField('task', field.name, { name: field_dd, id:index })" ><a href="javascript:void(0)">{{ field_dd }}</a></li>
                                  </ul>
                              </div>
                          </div> -->
                        </div>
                        <button class="close close-custom position-absolute" @click="removeSelectedValue(field.name)"
                                v-if="hasValueSelectedTask(field.name)">
                          <i class="fa fa-times"></i>
                        </button>
                      </div>
                    </div>
                    <!-- dropdown -->
                    <div v-if="field.field_type == 'select'" class="item-detail">
                      <div class="col-auto d-flex align-items-center">
                        <div class="dropdown action-tab-select-down">
                          <input class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
                                 v-bind:id="'mapFieldEditTaskDD-'+field.name" type="button"
                                 :value="containsKey(MapValuesTask, field.name)" data-toggle="dropdown"
                                 aria-haspopup="true" aria-expanded="false"/>
                          <div class="dropdown-menu action-tab-select-down-menu" style="padding: 0px;"
                               aria-labelledby="dropdownMenuButton">
                            <div class="popup-search-filter-items">
                              <ul>
                                <li v-for="field_dd in field.select_values"
                                    @click="SelectMapField('task', field.name, field_dd)"><a href="javascript:void(0)">{{
                                    field_dd
                                  }}</a></li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <button class="close close-custom position-absolute" @click="removeSelectedValue(field.name)"
                                v-if="hasValueSelectedTask(field.name)">
                          <i class="fa fa-times"></i>
                        </button>
                      </div>
                    </div>

                    <!-- Other types -->
                    <div v-else>
                      <div
                          v-if="field.name == 'created_by' || field.name == 'modified_by' || field.name == 'assigned_to'"
                          class="item-detail">
                        <div class="col-auto d-flex align-items-center">
                          <div class="dropdown action-tab-select-down">
                            <input
                                class="btn btn-secondary apply-btn-color dropdown-toggle action-dropdown-toggle"
                                v-bind:id="'mapFieldTaskDD-'+field.name"
                                type="button"
                                v-on:click.stop.prevent="openTaskAccordion(field.label)"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                v-bind:value="InitLabelForTask(field)"
                            />
                            <div v-if="fieldTypeOf(field) && field.field_type != 'autonumber'">
                              <div class="popup-container-main" v-if="checkDD_Task(field.label)"
                                   :id="'popup-container-main-'+level" style="left: 0;top: 100%;"
                                   v-click-outside="outside_task">
                                <div class="popup-container popup-container-modify">
                                  <div class="popup-search-filter">
                                    <div class="workflow-selected-field">
                                      <span>{{ lang.select + ' ' + lang.value }}</span>
                                    </div>
                                  </div>
                                  <div class="workflow-accordion-conautomation_template_editortainer-modify-record">
                                    <AccordionForCreateRecord
                                        :level="level"
                                        :table="SelectedTable.label"
                                        :fields="SelectedTable.fields"
                                        :users="UserTableParent"
                                        :lang="lang"
                                        :mapping_for="field"
                                        :custom="false"
                                        :field_type="field.field_type"
                                        v-on:CreateRecordOptionSelectedEvent="TaskRecordOptionSelected"
                                        :SelectedTableExcludedColumnList="RemoveIDValueForTaskAccordion(SelectedTableExcludedColumnList)"
                                        :CreateRecordMapping="CreateRecordMapping"
                                        :executeHandler="3"
                                    ></AccordionForCreateRecord>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <button class="close close-custom position-absolute" @click="removeSelectedValue(field.name)"
                                  v-if="hasValueSelectedTask(field.name)">
                            <i class="fa fa-times"></i>
                          </button>
                        </div>
                      </div>
                      <div v-else-if="field.type == 'date' || field.type == 'datetime'">
                        <div class="position-relative test-query-input">
                          <VueCtkDateTimePicker
                              v-if="field.type == 'date'"
                              :format="setDynamicFormat()"
                              :formatted="setDynamicFormat()"
                              v-model="MapValuesTask[field.name]"
                              :no-label="true"
                              :noClearButton="true"
                              label=""
                              :locale="lang.code"
                              :button-now-translation="lang.now"
                              :only-date="true"
                              :position="'bottom'"
                          />
                          <VueCtkDateTimePicker
                              v-else
                              :format="setDynamicFormat()+' HH:mm'"
                              :formatted="setDynamicFormat()+' HH:mm'"
                              v-model="MapValuesTask[field.name]"
                              :no-label="true"
                              :noClearButton="true"
                              :locale="lang.code"
                              :button-now-translation="lang.now"
                              label=""
                              :position="'bottom'"
                          />
                        </div>
                      </div>
                      <div v-else>
                        <input v-if="field.name != 'contact_name' && field.name != 'person'" type="text"
                               v-model="MapValuesTask[field.name]" :ref="field.name" :id="field.name"
                               class="test-query-field">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default wf-modal-cancel" data-dismiss="modal">
            {{ lang.cancel }}
          </button>
          <button type="button" class="btn btn-primary apply-btn-color wf-modal-save" @click="SaveAction()">
            {{ lang.save }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CreateTaskModal',
  props: [
    'SelectedTableId',
    'entity_id',
    'url',
    'categories',
    'Auth',
    'lang',
    'level',
    'SelectedTableExcludedColumnListReationship',
    'SelectedTableExcludedColumnList',
  ],
  components: {
    // Pixel
  },
  data() {
    return {
      SelectedTable: [],
      UserTable: [],
      MapValuesTask: [],
      TaskTable: [],
      // values for task creation
      create_task: {
        assigned_to: null,
        subject: null,
        contact_name: null,
        start_datetime: null,
        end_datetime: null,
        person: null,
        category: null,
        status: null,
        priority: null,
        long_description: null,
      },
      Data: [],
      data_status: null,

      // for validation
      create_task_error: {
        assigned_to: false,
        subject: false,
        contact_name: false,
        start_datetime: false,
        end_datetime: false,
        person: false,
        category: false,
        status: false,
        priority: false,
        long_description: false,
      },
      ActiveAccordionTask: [],
      ExceptionFieldType: ['date', 'datetime'],
      CreateRecordMapping: [],
      UserTableParent: []
    }
  },
  mounted() {

  },
  watch: {
    SelectedTableId() {
      this.GetSelectedTableData();
      this.GetTaskTableData();
      this.GetContactTableData();
    }
  },
  methods: {
    GetTaskTableData() {
      axios.post('/task-table-fields').then(response => {
        if (response.data.success) {
          this.TaskTable = response.data.data;
        }
      });
    },
    // get data from contact table
    GetContactTableData() {
      axios.post('/contact-table-data').then(response => {
        if (response.data.success) {
          this.UserTableParent = response.data.result;
        }
      });
    },
    setDynamicFormat() {
      switch (this.Auth.formatting.date_order) {
        case 'd-m-Y':
          return this.setDateSeparator('DD-MM-YYYY');
          break;
        case 'm-d-Y':
          return this.setDateSeparator('MM-DD-YYYY');
          break;
        case 'Y-m-d' :
          return this.setDateSeparator('YYYY-MM-DD');
          break;
        case 'Y-d-m' :
          return this.setDateSeparator('YYYY-DD-MM');
          break;
        default :
          return this.setDateSeparator('DD-MM-YYYY');
      }
    },
    setDateSeparator(format) {

      if (this.Auth.formatting.date_separator) {
        let _separator = this.Auth.formatting.date_separator;
        return format.replace(/-/g, _separator);
      } else {
        return format;
      }
    },
    hasSelectedDataTask(mappingData, field) {

      if (field == 'from') {
        if (mappingData['from']) {
          return true;
        }
        return false;

      } else if (field == 'recipient') {
        if (mappingData['recipient']) {
          return true;
        }
        return false;

      } else if (field == 'cc') {
        if (mappingData['cc']) {
          return true;
        }
        return false;

      } else if (field == 'category') {
        if (mappingData['category']) {
          return true;
        }
        return false;

      } else if (field == 'responsible') {
        if (mappingData['responsible']) {
          return true;
        }
        return false;
      }
    },

    hasValueSelectedTask(name) {
      if (this.create_task[name] != null || this.MapValuesTask[name] != null) {
        return true;
      }

      return false;
    },

    RemoveIDValueForTaskAccordion(data) {
      let _index = data.findIndex(x => x.name == 'id');

      if (_index > -1) {
        data.splice(_index, 1);
      }

      return data;
    },

    removeSelectedValue(name) {
      this.create_task[name] = null;

      if (this.MapValuesTask[name] != undefined) {
        this.MapValuesTask[name] = null;
      }

      // reset the field
      document.getElementById('mapFieldTaskDD-' + name).value = this.lang.select + ' ' + this.lang.value;
    },

    removeSelectedItemTask(mappingData, field) {

      mappingData[field] = null;

      if (document.getElementById('mapFieldEditTaskDD-' + field)) {
        document.getElementById('mapFieldEditTaskDD-' + field).value = this.lang.select + ' ' + this.lang.value;
      }

      if (document.getElementById('mapFieldEmailDD-' + field)) {
        document.getElementById('mapFieldEmailDD-' + field).value = this.lang.select + ' ' + this.lang.value;
      }
    },

    LoadDefaults(action_id, _data = null, _data_status = null) {
      // reset the form values
      this.MapValuesTask = [];

      // Get saved data from db for edit action modal
      if (_data_status != null) {
        this.data_status = _data_status;
      } else {
        this.data_status = null;
      }

      if (_data == null) {
        axios.post('/get-data-for-edit-modal', {'action_id': action_id}).then(response => {
          if (response.data.success) {
            this.MapValuesTask = response.data.result.action_map.create_task;
            this.create_task = response.data.result.action_map.create_task;

            this.Data = response.data.result;
          }
        });
      } else {
        this.MapValuesTask = _data.create_task.create_task;
        this.create_task = _data.create_task.create_task;
        this.Data = _data;
      }
    },
    // get the values of the present table
    GetSelectedTableData() {
      axios.post('/selected-table', {'table_id': this.SelectedTableId}).then(response => {
        if (response.data.success) {
          this.SelectedTable = response.data.result;
          this.UserTable = response.data.result.user_name;
        }
      });
    },
    // SelectMapField(field_id, field_dd){
    //     if(field_id == 'category'){
    //         this.MapValuesTask[field_id] = field_dd.category;
    //         document.getElementById('mapFieldTask-'+field_id).value = field_dd.category;
    //     }
    //     if(field_id == 'responsible'){
    //         this.MapValuesTask[field_id] = field_dd;
    //         document.getElementById('mapFieldTask-'+field_id).value = field_dd.name;
    //     }
    //     if(field_id == 'related_to'){
    //         this.MapValuesTask[field_id] = this.SelectedTable.label + "." + field_dd.label;
    //         document.getElementById('mapFieldTask-'+field_id).value = this.SelectedTable.label + "." + field_dd.label;
    //     }
    // },
    SaveAction() {
      // for validation
      let input_flag = 0;

      for (let error in this.MapValuesTask) {
        this.create_task_error[error] = false;
      }
      if (input_flag == 0) {
        this.SaveActionAfterValidation();
      }

    },
    SaveActionAfterValidation() {
      let data = {};

      if (this.data_status == "saved") {
        data = {
          action_id: this.entity_id,
          create_task: {
            create_task: {
              assigned_to: this.MapValuesTask.assigned_to,
              subject: this.MapValuesTask.subject,
              contact_name: this.MapValuesTask.contact_name,
              start_datetime: this.MapValuesTask.start_datetime,
              end_datetime: this.MapValuesTask.end_datetime,
              person: this.MapValuesTask.person,
              category: this.MapValuesTask.category,
              status: this.MapValuesTask.status,
              priority: this.MapValuesTask.priority,
              long_description: this.MapValuesTask.long_description,
              isEdit: true,
            },
            level: this.Data.level
          }
        };
      } else {
        data = {
          action_id: null,
          create_task: {
            create_task: {
              assigned_to: this.MapValuesTask.assigned_to,
              subject: this.MapValuesTask.subject,
              contact_name: this.MapValuesTask.contact_name,
              start_datetime: this.MapValuesTask.start_datetime,
              end_datetime: this.MapValuesTask.end_datetime,
              person: this.MapValuesTask.person,
              category: this.MapValuesTask.category,
              status: this.MapValuesTask.status,
              priority: this.MapValuesTask.priority,
              long_description: this.MapValuesTask.long_description,
            },
            level: this.Data.create_task.level
          }
        };
      }
      $('#create-task-modal').modal('hide');
      this.$emit('UpdateTaskActionEvent', data);
    },
    containsKey(obj, key) {
      if (key == 'assigned_to') {
        if (obj[key]) {
          return obj[key]['name'];
        } else {
          return this.lang.select + ' ' + this.lang.value;
        }
      } else if (key == 'person' || key == 'contact_name') {
        if (this.create_task[key] != null) {
          return obj[this.create_task[key]];
        } else if (obj[this.MapValuesTask[key]]) {
          return obj[this.MapValuesTask[key]];
        } else {
          return this.lang.select + ' ' + this.lang.value;
        }
      } else {
        if (obj[key]) {
          return obj[key];
        } else {
          return this.lang.select + ' ' + this.lang.value;
        }
      }
    },
    InitLabelForTask(field) {
      if (this.create_task[field.name] == null) {
        return this.lang.select + ' ' + this.lang.value;
      } else {
        console.log(this.create_task[field.name]);
        if (this.create_task[field.name]['record_type'] == 'custom') {
          return this.create_task[field.name]['selected_field']['name'];
        } else if (this.create_task[field.name]['record_type'] == 'old') {
          return 'Old.' + this.create_task[field.name]['selected_field']['label'];
        } else if (this.create_task[field.name]['record_type'] == 'new') {
          return this.create_task[field.name]['selected_field']['label'];
        } else if (this.create_task[field.name]['record_type'] == 'user') {
          return this.create_task[field.name]['selected_field']['name'];
        }
      }
    },
    outside_task() {
      this.ActiveAccordionTask = [];
    },
    checkDD_Task(field) {
      var _index = this.ActiveAccordionTask.findIndex(x => x == field);
      if (_index != -1) {
        return true;
      } else {
        return false;
      }
    },
    openTaskAccordion(label) {
      var _index = this.ActiveAccordionTask.findIndex(x => x == label);
      if (_index == -1) {
        this.ActiveAccordionTask = [];
        this.ActiveAccordionTask.push(label);
      } else {
        this.ActiveAccordionTask = [];
      }
    },
    SelectMapField(event, field_id, field_dd, field_name = null) {
      if (event == 'task' && field_dd != undefined) {
        if (field_id == 'assigned_to') {
          this.create_task[field_id] = field_dd;
          this.MapValuesTask[field_id] = field_dd;
          document.getElementById('mapFieldTaskDD-' + field_id).value = field_dd.name;
        }

        if (field_id == 'contact_name') {
          this.create_task[field_id] = field_dd.id;
          this.MapValuesTask[field_id] = field_dd.id;
          document.getElementById('mapFieldTaskDD-' + field_id).value = field_dd.name;
        }

        if (field_id == 'start_datetime') {
          this.create_task[field_id] = field_dd;
          this.MapValuesTask[field_id] = field_dd;
        }

        if (field_id == 'end_datetime') {
          this.create_task[field_id] = field_dd;
          this.MapValuesTask[field_id] = field_dd;
        }

        if (field_id == 'person') {
          this.create_task[field_id] = field_dd.id;
          this.MapValuesTask[field_id] = field_dd.id;
          document.getElementById('mapFieldTaskDD-' + field_id).value = field_dd.name;
        }

        if (field_id == 'subject') {
          this.create_task[field_id] = field_dd;
          this.MapValuesTask[field_id] = field_dd;
        }

        if (field_id == 'category') {
          this.create_task[field_id] = field_dd;
          this.MapValuesTask[field_id] = field_dd;
          document.getElementById('mapFieldTaskDD-' + field_id).value = field_dd;
        }
        if (field_id == 'status') {
          this.create_task[field_id] = field_dd;
          this.MapValuesTask[field_id] = field_dd;
          document.getElementById('mapFieldTaskDD-' + field_id).value = field_dd;
        }

        if (field_id == 'priority') {
          this.create_task[field_id] = field_dd;
          this.MapValuesTask[field_id] = field_dd;
          document.getElementById('mapFieldTaskDD-' + field_id).value = field_dd;
        }

        if (field_id == 'long_description') {
          this.create_task[field_id] = field_dd;
          this.MapValuesTask[field_id] = field_dd;
        }
      }
    },
    hasSelectedDataEmailTask() {

    },
    fieldTypeOf(FieldType) {

      let isIncludeSelctedField = this.ExceptionFieldType.includes(FieldType.type);

      if (isIncludeSelctedField) {
        return false;
      }

      return true;
    },
    TaskRecordOptionSelected(data) {
      let _value = {
        'mapping_for': data['mapping_for']['name'],
        'record_type': data['record_type'],
        'selected_field': data['selected_field'],
        'label': data['selected_field']['label']
      };

      this.create_task[data['mapping_for']['name']] = _value;
      this.outside_task();
    },
  }


}
</script>
